export default __webpack_public_path__ + "929a666f28ca323576deead35848212e.svg";